/**
 * `doc_profile.category` — what KIND of clinician a doctorProfile is.
 *
 * The list is bridge's, from the admin screen that creates these records
 * (modules/sales/modules/doctors/components/Doctors.js). It is `required` on
 * that form and DISABLED once set, so a record created there always carries one
 * and it never changes afterwards.
 *
 * Not a speciality: `doctorProfile.speciality` is free text ("Cardiologist")
 * that prints on a prescription. This is the coarse role, and it is the only
 * field on the stored profile that separates a doctor from a nutritionist.
 */
const DoctorCategory = {
  DOCTOR: 1,
  NUTRITIONIST: 2,
  MEDICAL_TEAM: 3,
  PHYSIOTHERAPIST: 4,
  PSYCHOTHERAPIST: 5,
};

export default DoctorCategory;
